var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-3 p-2 bg-white" }, [
    _c("div", { staticClass: "col-3 p-0" }, [
      _c(
        "a",
        {
          staticClass: "text-reset text-decoration-none",
          attrs: { href: _vm.page.url }
        },
        [
          _c("wf-load-image", {
            attrs: {
              wrapperClass: "w-100",
              imageClass: "image full-image blog-image",
              src: _vm.page.imageUrl,
              alt: _vm.page.title
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-9" }, [
      _c("div", { staticClass: "ml-3 mt-2" }, [
        _c("div", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.page.type))
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "page-subtitle",
          domProps: {
            innerHTML: _vm._s(
              _vm.$helpers.matchText(_vm.page.title, _vm.searchTerm)
            )
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "page-date" }, [
          _vm._v(_vm._s(_vm.page.date))
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "text-reset text-decoration-none",
            attrs: { href: _vm.page.url }
          },
          [
            _c("div", { staticClass: "page-description" }, [
              _vm._v(_vm._s(_vm.page.content))
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }